import { render, staticRenderFns } from "./AppBottomToolbar.vue?vue&type=template&id=3d921bb9&scoped=true"
import script from "./AppBottomToolbar.vue?vue&type=script&lang=ts"
export * from "./AppBottomToolbar.vue?vue&type=script&lang=ts"
import style0 from "./AppBottomToolbar.vue?vue&type=style&index=0&id=3d921bb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d921bb9",
  null
  
)

export default component.exports